// extracted by mini-css-extract-plugin
module.exports = {"list":"ChapterItems_list__kW9Em","moreBtn":"ChapterItems_moreBtn__ZpKFP"};